import React from "react";

const state = {
  currencies: undefined
};

const MainContext = React.createContext(state.currencies); //passing initial value

export default MainContext;
